<template>
  <div id="app">
    {{ stateSync }}
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  computed: {
    stateSync() {
      var stt = this.$store.state;
      localStorage.setItem("simpAdminState", JSON.stringify(stt));
      return "";
    },
  },
  created() {
    var savedstate = localStorage.getItem("simpAdminState");
    if (savedstate != null) {
      this.$store.replaceState(JSON.parse(savedstate));
    }
  },
};
</script>

<style>
/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
*/
</style>
